(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-tanoor-tradition"] && !Shopify.designMode) return;
  try {
    

(() => {
  const bindLanguageForms = root => {
    root.querySelectorAll('.ttr-language-form').forEach(form => {
      if (form.hasAttribute('data-ttr-language-ready')) return;
      const returnTo = form.querySelector('input[name="return_to"]');
      const view = form.closest('.ttr-language-bar').getAttribute('data-ttr-language-view');
      if (!returnTo || !view) return;
      const updateReturnTo = () => {
        const destination = new URL(window.location.href);
        destination.searchParams.set('view', view);
        returnTo.value = destination.pathname + destination.search + destination.hash;
      };
      updateReturnTo();
      form.addEventListener('submit', updateReturnTo);
      form.setAttribute('data-ttr-language-ready', '');
    });
  };
  const storageKey = 'top_tanoor_ad_name';
  const cleanAdReference = value => {
    const reference = String(value || '').trim();
    if (!reference || reference.toLowerCase() === 'website' || reference.includes(String.fromCharCode(123, 123))) return '';
    return reference.slice(0, 100);
  };
  const getAdReference = () => {
    const current = new URLSearchParams(window.location.search).get('utm_content');
    let reference = cleanAdReference(current);
    try {
      if (current === null) {
        reference = cleanAdReference(sessionStorage.getItem(storageKey));
      }
      if (reference) sessionStorage.setItem(storageKey, reference);
      else sessionStorage.removeItem(storageKey);
    } catch {}
    return reference;
  };
  const bindWhatsappLinks = root => {
    root.querySelectorAll('.ttv-review .ttv-whatsapp').forEach(link => {
      if (link.hasAttribute('data-ttv-tracking-ready')) return;
      let destination;
      try { destination = new URL(link.href); } catch { return; }
      if (destination.hostname !== 'api.whatsapp.com') return;
      const message = (destination.searchParams.get('text') || '').replace(/^Ref:\s*[^|]*\|\s*/i, '');
      const updateLink = () => {
        const reference = getAdReference();
        destination.searchParams.set('text', reference ? `Ref: ${reference} | ${message}` : message);
        link.href = destination.toString();
      };
      updateLink();
      link.addEventListener('click', updateLink);
      link.addEventListener('contextmenu', updateLink);
      link.setAttribute('data-ttv-tracking-ready', '');
    });
  };
  const bindEnquiryForms = root => {
    root.querySelectorAll('.ttv-review form.ttr-enquiry-form').forEach(form => {
      if (form.hasAttribute('data-ttv-enquiry-ready')) return;
      const button = form.querySelector('.ttr-enquiry-submit');
      const errorBox = form.querySelector('[data-ttr-crm-error]');
      const successBox = form.closest('.ttr-enquiry').querySelector('[data-ttr-crm-success]');
      const endpoint = form.getAttribute('data-ttr-crm-endpoint');
      if (!button || !errorBox || !successBox || !endpoint) return;
      const buttonLabel = button.textContent;
      let pending = false;
      let requestId = '';
      let previousPayload = '';
      const newRequestId = () => {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
          const random = Math.floor(Math.random() * 16);
          return (character === 'x' ? random : ((random & 3) | 8)).toString(16);
        });
      };
      const updateAttribution = () => {
        const adField = form.querySelector('[data-ttr-ad-reference]');
        const pageField = form.querySelector('[data-ttr-source-page]');
        if (adField) adField.value = getAdReference();
        if (pageField) {
          const source = new URL(window.location.pathname, window.location.origin);
          const view = new URLSearchParams(window.location.search).get('view');
          const allowedViews = ['vsl-1','vsl-any-day','vsl-eid-weekend','vsl-made-simple','vsl-no-digging','vsl-no-pit'];
          if (allowedViews.includes(view)) source.searchParams.set('view', view);
          pageField.value = source.toString();
        }
      };
      const showResult = element => {
        element.hidden = false;
        element.focus({ preventScroll: true });
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        element.scrollIntoView({ block: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
      };
      updateAttribution();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending || !form.reportValidity()) return;
        updateAttribution();
        const data = new FormData(form);
        const value = name => String(data.get(name) || '').trim();
        const payload = {
          name: value('contact[name]'),
          phone: value('contact[phone]'),
          email: value('contact[email]').toLowerCase(),
          location: value('contact[Delivery location]'),
          model: value('contact[Preferred model]'),
          angle: value('contact[VSL angle]'),
          language: value('contact[Language]'),
          ad_reference: value('contact[Ad reference]'),
          source_page: value('contact[Source page]'),
          website: value('website')
        };
        const fingerprint = JSON.stringify(payload);
        if (!requestId || previousPayload !== fingerprint) {
          requestId = newRequestId();
          previousPayload = fingerprint;
        }
        payload.request_id = requestId;
        pending = true;
        errorBox.hidden = true;
        errorBox.textContent = '';
        form.setAttribute('aria-busy', 'true');
        const editableFields = Array.from(form.querySelectorAll('input:not([type="hidden"]),select,textarea')).filter(field => !field.disabled);
        editableFields.forEach(field => { field.disabled = true; });
        button.disabled = true;
        button.textContent = form.getAttribute('data-ttr-sending-label');
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 45000);
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            signal: controller.signal
          });
          const confirmation = await response.json().catch(() => null);
          if (!response.ok || !confirmation || confirmation.success !== true) {
            const failure = new Error('Enquiry not confirmed');
            failure.validationError = response.status === 400 || response.status === 422;
            throw failure;
          }
          form.hidden = true;
          showResult(successBox);
        } catch (failure) {
          errorBox.textContent = form.getAttribute(failure.validationError ? 'data-ttr-validation-error' : 'data-ttr-send-error');
          showResult(errorBox);
        } finally {
          window.clearTimeout(timeout);
          editableFields.forEach(field => { field.disabled = false; });
          form.removeAttribute('aria-busy');
          pending = false;
          button.disabled = false;
          button.textContent = buttonLabel;
        }
      });
      form.setAttribute('data-ttv-enquiry-ready', '');
      button.disabled = false;
    });
  };
  const bindVslActions = root => {
    bindLanguageForms(root);
    bindWhatsappLinks(root);
    bindEnquiryForms(root);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindVslActions(document), { once: true });
  } else {
    bindVslActions(document);
  }
  document.addEventListener('shopify:section:load', event => bindVslActions(event.target));
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-tanoor-vsl-ads"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ttv-story-player')) {
  customElements.define('ttv-story-player', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      this.setAttribute('data-ready', '');
      button.hidden = false;
      video.addEventListener('playing', () => { button.hidden = true; });
      video.addEventListener('pause', () => { button.hidden = false; });
      video.addEventListener('ended', () => { button.hidden = false; });
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          await video.play();
          button.hidden = true;
          video.focus({ preventScroll: true });
        } catch {
          button.hidden = false;
        } finally {
          button.disabled = false;
        }
      });
    }
  });
}

(() => {
  const storageKey = 'top_tanoor_ad_name';
  const cleanAdReference = value => {
    const reference = String(value || '').trim();
    if (!reference || reference.toLowerCase() === 'website' || reference.includes(String.fromCharCode(123, 123))) return '';
    return reference.slice(0, 100);
  };
  const getAdReference = () => {
    const current = new URLSearchParams(window.location.search).get('utm_content');
    let reference = cleanAdReference(current);
    try {
      if (current === null) {
        reference = cleanAdReference(sessionStorage.getItem(storageKey));
      }
      if (reference) sessionStorage.setItem(storageKey, reference);
      else sessionStorage.removeItem(storageKey);
    } catch {}
    return reference;
  };
  const bindWhatsappLinks = root => {
    root.querySelectorAll('.ttv-review .ttv-whatsapp').forEach(link => {
      if (link.hasAttribute('data-ttv-tracking-ready')) return;
      let destination;
      try { destination = new URL(link.href); } catch { return; }
      if (destination.hostname !== 'api.whatsapp.com') return;
      const message = (destination.searchParams.get('text') || '').replace(/^Ref:\s*[^|]*\|\s*/i, '');
      const updateLink = () => {
        const reference = getAdReference();
        destination.searchParams.set('text', reference ? `Ref: ${reference} | ${message}` : message);
        link.href = destination.toString();
      };
      updateLink();
      link.addEventListener('click', updateLink);
      link.addEventListener('contextmenu', updateLink);
      link.setAttribute('data-ttv-tracking-ready', '');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindWhatsappLinks(document), { once: true });
  } else {
    bindWhatsappLinks(document);
  }
  document.addEventListener('shopify:section:load', event => bindWhatsappLinks(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-tanoor-vsl-review"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ttv-story-player')) {
  customElements.define('ttv-story-player', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      this.setAttribute('data-ready', '');
      button.hidden = false;
      video.addEventListener('playing', () => { button.hidden = true; });
      video.addEventListener('pause', () => { button.hidden = false; });
      video.addEventListener('ended', () => { button.hidden = false; });
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          await video.play();
          button.hidden = true;
          video.focus({ preventScroll: true });
        } catch {
          button.hidden = false;
        } finally {
          button.disabled = false;
        }
      });
    }
  });
}

(() => {
  const storageKey = 'top_tanoor_ad_name';
  const cleanAdReference = value => {
    const reference = String(value || '').trim();
    if (!reference || reference.toLowerCase() === 'website' || reference.includes(String.fromCharCode(123, 123))) return '';
    return reference.slice(0, 100);
  };
  const getAdReference = () => {
    const current = new URLSearchParams(window.location.search).get('utm_content');
    let reference = cleanAdReference(current);
    try {
      if (current === null) {
        reference = cleanAdReference(sessionStorage.getItem(storageKey));
      }
      if (reference) sessionStorage.setItem(storageKey, reference);
      else sessionStorage.removeItem(storageKey);
    } catch {}
    return reference;
  };
  const bindWhatsappLinks = root => {
    root.querySelectorAll('.ttv-review .ttv-whatsapp').forEach(link => {
      if (link.hasAttribute('data-ttv-tracking-ready')) return;
      let destination;
      try { destination = new URL(link.href); } catch { return; }
      if (destination.hostname !== 'api.whatsapp.com') return;
      const message = (destination.searchParams.get('text') || '').replace(/^Ref:\s*[^|]*\|\s*/i, '');
      const updateLink = () => {
        const reference = getAdReference();
        destination.searchParams.set('text', reference ? `Ref: ${reference} | ${message}` : message);
        link.href = destination.toString();
      };
      updateLink();
      link.addEventListener('click', updateLink);
      link.addEventListener('contextmenu', updateLink);
      link.setAttribute('data-ttv-tracking-ready', '');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindWhatsappLinks(document), { once: true });
  } else {
    bindWhatsappLinks(document);
  }
  document.addEventListener('shopify:section:load', event => bindWhatsappLinks(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-cooking-guide-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const subscribedKey = 'tt_cooking_guide_subscribed_v1';
  const dismissedKey = 'tt_cooking_guide_dismissed_v1';
  const pendingKey = 'tt_cooking_guide_pending_v1';
  const pendingTTL = 10 * 60 * 1000;
  const newRequestId = () => {
    if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();
    if (typeof window.crypto?.getRandomValues !== 'function') return null;
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  };
  const safeGet = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const safeSet = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  const clearPending = () => { try { sessionStorage.removeItem(pendingKey); } catch {} };
  const readAttribution = () => {
    const params = new URLSearchParams(location.search);
    let value = '';
    if (params.has('utm_content')) {
      value = (params.get('utm_content') || '').trim().slice(0, 100);
      if (!value || value.toLowerCase() === 'website' || value.includes('{{')) {
        try { sessionStorage.removeItem('top_tanoor_ad_name'); } catch {}
        return '';
      }
      try { sessionStorage.setItem('top_tanoor_ad_name', value); } catch {}
      return value;
    }
    try { value = (sessionStorage.getItem('top_tanoor_ad_name') || '').trim().slice(0, 100); } catch {}
    return value.toLowerCase() === 'website' || value.includes('{{') ? '' : value;
  };
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    readAttribution();
    const explicitPreview = new URLSearchParams(location.search).get('tt-guide-preview') === '1';
    const designMode = root.dataset.designMode === 'true';
    const preview = designMode || explicitPreview;
    if (!preview && document.body.classList.contains('tt-vsl-focused')) return;
    let endpoint;
    try { endpoint = new URL(root.dataset.endpoint, location.origin); } catch {}
    const endpointReady = Boolean(root.dataset.endpoint && endpoint && endpoint.protocol === 'https:');
    if (!preview && (root.dataset.enabled !== 'true' || !endpointReady)) return;
    const dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const form = root.querySelector('.tt-cooking-guide__form');
    const submit = root.querySelector('[data-guide-submit]');
    const retry = root.querySelector('[data-guide-retry]');
    const status = root.querySelector('[data-guide-status]');
    const openButton = root.querySelector('[data-guide-open]');
    const closeButton = root.querySelector('[data-guide-close]');
    const download = root.querySelector('[data-guide-download]');
    const email = root.querySelector('[data-guide-email]');
    const nameInput = root.querySelector('[data-guide-name]');
    const phone = root.querySelector('[data-guide-phone]');
    const countryInput = root.querySelector('[data-guide-country]');
    const consent = form.elements.marketing_consent;
    const submitText = submit.textContent;
    const startedAt = Date.now();
    let inFlight = false;
    let focusBeforeOpen;
    let overflowBeforeOpen;
    let timer;
    let nativeTimer;
    let pending;
    let disposed = false;
    let requestController;
    submit.disabled = false;
    openButton.hidden = false;
    root.querySelector('[data-guide-preview]').hidden = !preview;
    if (!preview) {
      try {
        const stored = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
        const valid = stored && Date.now() - stored.created_at < pendingTTL && stored.created_at <= Date.now() && stored.payload && stored.payload.marketing_consent === true && typeof stored.payload.request_id === 'string';
        if (valid && (stored.payload.source_path === location.pathname || stored.shopify_returned === true)) pending = stored;
        else if (stored && !valid) clearPending();
      } catch { clearPending(); }
    }
    const savePending = value => {
      try {
        sessionStorage.setItem(pendingKey, JSON.stringify(value));
        return true;
      } catch { return false; }
    };
    const open = () => {
      if (!dialog.isConnected || dialog.open) return;
      focusBeforeOpen = document.activeElement;
      overflowBeforeOpen = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => dialog.close();
    openButton.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    root.addEventListener('tt-guide-open', open);
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = overflowBeforeOpen || '';
      if (!preview) safeSet(dismissedKey, String(Date.now()));
      if (focusBeforeOpen && focusBeforeOpen.isConnected) focusBeforeOpen.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    const setStatus = (message, error = false) => {
      if (disposed) return;
      status.textContent = message;
      status.hidden = false;
      status.setAttribute('role', error ? 'alert' : 'status');
      if (dialog.open) status.focus({ preventScroll: true });
    };
    const sendGuide = async () => {
      if (preview || inFlight || !pending || pending.shopify_returned !== true) return;
      if (Date.now() - pending.created_at >= pendingTTL) {
        clearPending();
        pending = null;
        retry.hidden = true;
        form.hidden = false;
        setStatus(root.dataset.errorText, true);
        return;
      }
      inFlight = true;
      form.hidden = true;
      retry.disabled = true;
      retry.hidden = true;
      setStatus(root.dataset.busyText);
      requestController = new AbortController();
      const timeout = setTimeout(() => requestController.abort(), 45000);
      try {
        const response = await fetch(endpoint.href, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'omit',
          body: JSON.stringify({ ...pending.payload, shopify_signup_returned: true }),
          signal: requestController.signal
        });
        if (!response.ok) throw new Error('Request failed');
        const result = await response.json();
        if (result.ok !== true || result.guide_sent !== true) throw new Error('Sending not confirmed');
        safeSet(subscribedKey, String(Date.now()));
        clearPending();
        pending = null;
        setStatus(root.dataset.successText);
        if (download.getAttribute('href')) {
          const guide = new URL(download.getAttribute('href'), location.origin);
          if (guide.protocol === 'https:') download.hidden = false;
        }
      } catch {
        if (!disposed) {
          retry.hidden = false;
          setStatus(root.dataset.deliveryError, true);
        }
      } finally {
        clearTimeout(timeout);
        inFlight = false;
        retry.disabled = false;
      }
    };
    phone.addEventListener('input', () => phone.setCustomValidity(''));
    form.addEventListener('submit', event => {
      if (preview) {
        event.preventDefault();
        setStatus(root.dataset.previewText);
        return;
      }
      if (inFlight) {
        event.preventDefault();
        return;
      }
      const phoneValue = phone.value.trim().replace(/[\s().-]/g, '').replace(/^00/, '+');
      if (phoneValue && !/^\+[1-9]\d{7,14}$/.test(phoneValue)) {
        event.preventDefault();
        phone.setCustomValidity(root.dataset.phoneError);
        phone.reportValidity();
        return;
      }
      if (!form.reportValidity()) {
        event.preventDefault();
        return;
      }
      const name = nameInput.value.trim();
      const country = countryInput.value.trim();
      if (name.length < 2 || (country && country.length < 2) || email.value.trim().length > 100) {
        event.preventDefault();
        setStatus(root.dataset.errorText, true);
        return;
      }
      const requestId = newRequestId();
      if (!requestId) {
        event.preventDefault();
        setStatus(root.dataset.errorText, true);
        return;
      }
      const payload = {
        schema_version: 1,
        request_id: requestId,
        email: email.value.trim(),
        name,
        phone: phoneValue,
        country,
        marketing_consent: consent.checked,
        language: (root.dataset.language || 'en').toLowerCase().startsWith('ar') ? 'ar' : 'en',
        lead_source: 'Website Lead Popup',
        source_path: location.pathname,
        ad_reference: readAttribution(),
        website: form.elements.website.value,
        elapsed_ms: Date.now() - startedAt
      };
      const sameEmail = pending && pending.payload.email.toLowerCase() === payload.email.toLowerCase();
      const sameRequest = pending && JSON.stringify({ ...pending.payload, request_id: '', elapsed_ms: 0 }) === JSON.stringify({ ...payload, request_id: '', elapsed_ms: 0 });
      if (sameRequest) payload.request_id = pending.payload.request_id;
      if (sameEmail && pending.shopify_returned === true) {
        event.preventDefault();
        pending.payload = payload;
        if (!savePending(pending)) {
          setStatus(root.dataset.storageError, true);
          return;
        }
        sendGuide();
        return;
      }
      pending = { created_at: Date.now(), shopify_returned: false, payload };
      if (!savePending(pending)) {
        event.preventDefault();
        setStatus(root.dataset.storageError, true);
        return;
      }
      submit.textContent = root.dataset.busyText;
      form.setAttribute('aria-busy', 'true');
      clearTimeout(nativeTimer);
      nativeTimer = setTimeout(() => {
        submit.textContent = submitText;
        form.removeAttribute('aria-busy');
      }, 30000);
    });
    retry.addEventListener('click', sendGuide);
    if (pending) {
      email.value = pending.payload.email;
      nameInput.value = pending.payload.name;
      phone.value = pending.payload.phone;
      countryInput.value = pending.payload.country;
      consent.checked = pending.payload.marketing_consent === true;
      const nativeSuccess = root.querySelector('[data-guide-native-success]').dataset.guideNativeSuccess === 'true';
      if (nativeSuccess) {
        pending.shopify_returned = true;
        savePending(pending);
      }
      open();
      if (pending.shopify_returned) sendGuide();
      else if (!root.querySelector('.tt-cooking-guide__native-error')) setStatus(root.dataset.errorText, true);
    } else {
      const dismissedAt = Number(safeGet(dismissedKey) || 0);
      const suppressed = safeGet(subscribedKey) || Date.now() - dismissedAt < Number(root.dataset.dismissDays || 7) * 86400000;
      if (explicitPreview || (!preview && !suppressed && root.dataset.autoOpen !== 'false')) {
        timer = setTimeout(() => {
          const anotherDialog = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(element => {
            if (element === dialog || element.hidden || !element.getClientRects().length) return false;
            const style = getComputedStyle(element);
            return style.visibility !== 'hidden' && style.visibility !== 'collapse' && style.display !== 'none';
          });
          if (!anotherDialog) open();
        }, explicitPreview ? 250 : Number(root.dataset.delay || 20) * 1000);
      }
    }
    root.addEventListener('tt-guide-cleanup', () => {
      disposed = true;
      clearTimeout(timer);
      clearTimeout(nativeTimer);
      if (requestController) requestController.abort();
      if (dialog.open) close();
    }, { once: true });
  };
  document.querySelectorAll('[data-tt-cooking-guide]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-tt-cooking-guide]').forEach(init));
  document.addEventListener('shopify:section:select', event => event.target.querySelectorAll('[data-tt-cooking-guide]').forEach(root => root.dispatchEvent(new Event('tt-guide-open'))));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-tt-cooking-guide]').forEach(root => root.dispatchEvent(new Event('tt-guide-cleanup'))));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-homepage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  if (!event.target.closest('[data-tth-guide-open]')) return;
  const guide = document.querySelector('[data-tt-cooking-guide]');
  if (guide) guide.dispatchEvent(new Event('tt-guide-open'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-how-it-works"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const trigger = event.target.closest('[data-tthw-guide-open]');
  if (!trigger) return;
  const guide = document.querySelector('[data-tt-cooking-guide]');
  if (guide) guide.dispatchEvent(new Event('tt-guide-open'));
});

  } catch(e) { console.error(e); }
})();
})();
